var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('DataTable',{attrs:{"actions":true,"data":_vm.rolesList,"columns":_vm.tableConfig,"is-loading":_vm.isLoading},on:{"on-page-change":_vm.pageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }